import { to as tos } from 'await-to-js';
import router from './router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { getToken } from '@/utils/auth';
import { isHttp, isPathMatch } from '@/utils/validate';
import { isRelogin } from '@/utils/request';
import useUserStore from '@/store/modules/user';
import useSettingsStore from '@/store/modules/settings';
import usePermissionStore from '@/store/modules/permission';
import { addPageView } from '@/api/opus/websiteVisits/index';

NProgress.configure({ showSpinner: false });
const whiteList = [
  '/index',
  '/login',
  '/register',
  '/resetPassword',
  '/userAgreement',
  '/eventDetails',
  '/announcementDetails',
  '/social-callback',
  '/register*',
  '/register/*'
];

const isWhiteList = (path: string) => {
  return whiteList.some((pattern) => isPathMatch(pattern, path));
};

//  防抖函数：一小时内不重复触发。
let lastVisitTime = 0;
const debounceVisit = async () => {
  const now = Date.now();
  if (now - lastVisitTime > 3600000) {
    // 一小时限制
    lastVisitTime = now;
    console.log('触发访问统计接口调用');
    const res = await addPageView();
    console.log('访问统计 API', res);

    // 访问统计 API
  } else {
    console.log(`当前时间不够60min,现在只过了${Math.floor((now - lastVisitTime) / 1000)}s`);
  }
};

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  if (to.path == '/index') {
    // 单独处理index页面 ----开始
    debounceVisit(); // 触发访问统计
  }
  if (getToken()) {
    to.meta.title && useSettingsStore().setTitle(to.meta.title);
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' });
      NProgress.done();
    } else if (isWhiteList(to.path)) {
      if (to.path == '/index') {
        // 单独处理index页面 ----开始
        if (useUserStore().roles.length === 0) {
          isRelogin.show = true;
          // 判断当前用户是否已拉取完user_info信息
          const [err] = await tos(useUserStore().getInfo());
          if (err) {
            await useUserStore().logout();
            ElMessage.error(err);
            next({ path: '/' });
          } else {
            isRelogin.show = false;
            const accessRoutes = await usePermissionStore().generateRoutes();
            // 根据roles权限生成可访问的路由表
            accessRoutes.forEach((route) => {
              if (!isHttp(route.path)) {
                router.addRoute(route); // 动态添加可访问路由表
              }
            });
            // @ts-expect-error hack方法 确保addRoutes已完成
            next({ path: to.path, replace: true, params: to.params, query: to.query, hash: to.hash, name: to.name as string }); // hack方法 确保addRoutes已完成
          }
        } else {
          next();
        }
      }
      // 单独处理index页面 ----结束
      next();
    } else {
      if (useUserStore().roles.length === 0) {
        isRelogin.show = true;
        // 判断当前用户是否已拉取完user_info信息
        const [err] = await tos(useUserStore().getInfo());
        if (err) {
          await useUserStore().logout();
          ElMessage.error(err);
          next({ path: '/' });
        } else {
          isRelogin.show = false;
          const accessRoutes = await usePermissionStore().generateRoutes();
          // 根据roles权限生成可访问的路由表
          accessRoutes.forEach((route) => {
            if (!isHttp(route.path)) {
              router.addRoute(route); // 动态添加可访问路由表
            }
          });
          // @ts-expect-error hack方法 确保addRoutes已完成
          next({ path: to.path, replace: true, params: to.params, query: to.query, hash: to.hash, name: to.name as string }); // hack方法 确保addRoutes已完成
        }
      } else {
        next();
      }
    }
  } else {
    // 没有token
    if (isWhiteList(to.path)) {
      // 在免登录白名单，直接进入
      next();
    } else {
      const redirect = encodeURIComponent(to.fullPath || '/');
      next(`/login?redirect=${redirect}`); // 否则全部重定向到登录页
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
